import {
	FormattedCurrency,
	FormattedDateTime,
	IDataListColumn,
	PaginatedAutoDataList,
	laravelPaginatedListFetchConfig,
} from "@dgs/core";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { eventUserRequestService } from "../../../shared/api/eventUserRequestService";
import { EventUserRequestApprovedIndexResource } from "../../../shared/types/eventUserRequest";

export const EventUserRequestApprovedList: FC = () => {
	const { t } = useTranslation();
	const dataListColumns: IDataListColumn<EventUserRequestApprovedIndexResource>[] = useMemo(
		() => [
			{
				heading: t("Approver"),
				valueKey: "approver",
				type: "value",
				render: (eventRequest) => `${eventRequest.approver.name} (${eventRequest.approver.email})`,
			},
			{
				heading: t("Event name"),
				valueKey: "event.name",
				type: "value",
			},
			{
				heading: t("Event start"),
				valueKey: "event.start",
				type: "value",
				render: (eventRequest) => <FormattedDateTime dateTime={eventRequest.event.start} />,
			},
			{
				heading: t("Event end"),
				valueKey: "event.end",
				type: "value",
				render: (eventRequest) => <FormattedDateTime dateTime={eventRequest.event.end} />,
			},
			{
				heading: t("User"),
				valueKey: "user",
				type: "value",
				render: (eventRequest) => `${eventRequest.user.name} (${eventRequest.user.email})`,
			},
			{
				heading: t("Participation reason"),
				valueKey: "participationReason",
				type: "value",
			},
			{
				heading: t("Costs"),
				valueKey: "costs",
				type: "value",
				render: (eventRequest) => <FormattedCurrency value={eventRequest.costs} currencyType={eventRequest.currency} />,
			},
			{
				heading: t("Cost Center"),
				valueKey: "costCenterName",
				type: "value",
			},
			{
				heading: t("User cost approval"),
				valueKey: "requestedApprover",
				type: "value",
				render: (eventRequest) => `${eventRequest.requestedApprover.name} (${eventRequest.requestedApprover.email})`,
			},
			{
				heading: t("Approved at"),
				valueKey: "approvedAt",
				type: "value",
				render: ({ approvedAt }) => <FormattedDateTime dateTime={approvedAt} />,
			},
		],
		[t],
	);

	return (
		<PaginatedAutoDataList
			name="events"
			columns={dataListColumns}
			empty={t("No approved requests available")}
			heading={t("Approved requests")}
			listFetchConfig={laravelPaginatedListFetchConfig(
				eventUserRequestService.approvedRequestsKey,
				eventUserRequestService.indexApprovedRequests,
			)}
			initialSearch={{
				search: "",
				searchFields: [
					{ label: t("Event"), name: "event_translations.name" },
					{ label: t("User"), name: "user" },
				],
			}}
		/>
	);
};
